module.exports = __webpack_public_path__ + "media/images/svg-icon/layouts-34161605b7e24f5306792ad03de58ff6.svg";